import abLogo from './abLogo.png';
import headerSuccess from './header-success.svg';

export const imagesAb = {
	headerSuccess,
	abLogo,
};
